import { render, staticRenderFns } from "./WidgetBox.vue?vue&type=template&id=7a87d58c&"
import script from "./WidgetBox.vue?vue&type=script&lang=js&"
export * from "./WidgetBox.vue?vue&type=script&lang=js&"
import style0 from "./WidgetBox.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
